const ProjectTypes = {
    ADD_PROJECT: 'ADD_PROJECT',
    ADD_PROJECT_LOADING: 'ADD_PROJECT_LOADING',
    ADD_PROJECT_SUCCESS: 'ADD_PROJECT_SUCCESS',
    ADD_PROJECT_ERROR: 'ADD_PROJECT_ERROR',
    ADD_PROJECT_RESET: 'ADD_PROJECT_RESET',

    // get Catergory
    GET_PROJECT: "GET_PROJECT",
    GET_PROJECT_LOADING: "GET_PROJECT_LOADING",
    GET_PROJECT_SUCCESS: "GET_PROJECT_SUCCESS",
    GET_PROJECT_RESET: "GET_PROJECT_RESET",
    GET_PROJECT_ERROR: "GET_PROJECT_ERROR",

    // update project details

    UPDATE_PROJECT_DETAILS: "UPDATE_PROJECT_DETAILS",
    UPDATE_PROJECT_DETAILS_LOADING: "UPDATE_PROJECT_DETAILS_LOADING",
    UPDATE_PROJECT_DETAILS_SUCCESS: "UPDATE_PROJECT_DETAILS_SUCCESS",
    UPDATE_PROJECT_DETAILS_ERROR: "UPDATE_PROJECT_DETAILS_ERROR",
    UPDATE_PROJECT_DETAILS_RESET: "UPDATE_PROJECT_DETAILS_RESET",

    // update project status

    UPDATE_PROJECT_STATUS: "UPDATE_PROJECT_STATUS",
    UPDATE_PROJECT_STATUS_LOADING: "UPDATE_PROJECT_STATUS_LOADING",
    UPDATE_PROJECT_STATUS_SUCCESS: "UPDATE_PROJECT_STATUS_SUCCESS",
    UPDATE_PROJECT_STATUS_ERROR: "UPDATE_PROJECT_STATUS_ERROR",
    UPDATE_PROJECT_STATUS_RESET: "UPDATE_PROJECT_STATUS_RESET",

    // delete project

    DELETE_PROJECT_DETAILS: "DELETE_PROJECT_DETAILS",
    DELETE_PROJECT_DETAILS_LOADING: "DELETE_PROJECT_DETAILS_LOADING",
    DELETE_PROJECT_DETAILS_SUCCESS: "DELETE_PROJECT_DETAILS_SUCCESS",
    DELETE_PROJECT_DETAILS_ERROR: "DELETE_PROJECT_DETAILS_ERROR",
    DELETE_PROJECT_DETAILS_RESET: "DELETE_PROJECT_DETAILS_RESET",
    // get orojectById
    GET_PROJECT_BY_ID: "GET_PROJECT_BY_ID",
    GET_PROJECT_BY_ID_LOADING: "GET_PROJECT_BY_ID_LOADING",
    GET_PROJECT_BY_ID_SUCCESS: "GET_PROJECT_BY_ID_SUCCESS",
    GET_PROJECT_BY_ID_RESET: "GET_PROJECT_BY_ID_RESET",
    GET_PROJECT_BY_ID_ERROR: "GET_PROJECT_BY_ID_ERROR",

    GET_PROJECTS_COUNT: "GET_PROJECTS_COUNT",
    GET_PROJECTS_COUNT_LOADING: "GET_PROJECTS_COUNT_LOADING",
    GET_PROJECTS_COUNT_SUCCESS: "GET_PROJECTS_COUNT_SUCCESS",
    GET_PROJECTS_COUNT_RESET: "GET_PROJECTS_COUNT_RESET",
    GET_PROJECTS_COUNT_ERROR: "GET_PROJECTS_COUNT_ERROR",

    GET_PROJECT_USERS: "GET_PROJECT_USERS",
    GET_PROJECT_USERS_LOADING: "GET_PROJECT_USERS_LOADING",
    GET_PROJECT_USERS_SUCCESS: "GET_PROJECT_USERS_SUCCESS",
    GET_PROJECT_USERS_RESET: "GET_PROJECT_USERS_RESET",
    GET_PROJECT_USERS_ERROR: "GET_PROJECT_USERS_ERROR",

    GET_PROJECT_TIME_SPENT: "GET_PROJECT_TIME_SPENT",
    GET_PROJECT_TIME_SPENT_LOADING: "GET_PROJECT_TIME_SPENT_LOADING",
    GET_PROJECT_TIME_SPENT_SUCCESS: "GET_PROJECT_TIME_SPENT_SUCCESS",
    GET_PROJECT_TIME_SPENT_RESET: "GET_PROJECT_TIME_SPENT_RESET",
    GET_PROJECT_TIME_SPENT_ERROR: "GET_PROJECT_TIME_SPENT_ERROR",

    // AMC Projects
    GET_AMC_PROJECTS: "GET_AMC_PROJECTS",
    GET_AMC_PROJECTS_LOADING: "GET_AMC_PROJECTS_LOADING",
    GET_AMC_PROJECTS_SUCCESS: "GET_AMC_PROJECTS_SUCCESS",
    GET_AMC_PROJECTS_RESET: "GET_AMC_PROJECTS_RESET",
    GET_AMC_PROJECTS_ERROR: "GET_AMC_PROJECTS_ERROR",
};

export default ProjectTypes;
